 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"desktop_home":"desktop_home","desktop_layout":"desktop_layout","desktop_manage-account":"desktop_manage-account","desktop_redemption":"desktop_redemption","desktop_settings":"desktop_settings","forget-password~login":"forget-password~login","forget-password":"forget-password","login":"login","fulfillment":"fulfillment","layout-login":"layout-login","mobile_home":"mobile_home","mobile_layout":"mobile_layout","mobile_redemption":"mobile_redemption","mobile_user":"mobile_user","set-password":"set-password","verify-token":"verify-token"}[chunkId]||chunkId) + "." + {"chunk-0db6f456":"ab8df2fd","chunk-0df38b29":"cbbf8b69","chunk-1285c570":"c0a13c69","chunk-16b3d45c":"2da9fd26","chunk-18447cb4":"be204df7","chunk-1a2de8f4":"1f597273","chunk-1b7fd891":"035bd975","chunk-1c4bb97c":"1d6b314b","chunk-21b34fe2":"2cb24d03","chunk-29255102":"c3b5b09e","chunk-2a459ed1":"7de10c4f","chunk-2c7f2666":"5b9a0858","chunk-2d0a3c3b":"b4e9c2d5","chunk-2d0cfad7":"48bcbf30","chunk-2d0de76c":"448c4ab0","chunk-2d0f1136":"d94fee46","chunk-2d229396":"ef6dfbba","chunk-2f1ad42e":"04c2e6fc","chunk-31475960":"2bef5c9f","chunk-3bd7cd7e":"e4d685a5","chunk-3c705d88":"ffd9270e","chunk-3d0a6901":"2bb42646","chunk-43b7ffe8":"945ff24e","chunk-4420fbcc":"a6ca3fc8","chunk-4a20cf53":"266f9607","chunk-4a20f8c4":"52fee91f","chunk-4aba7826":"425c4f38","chunk-4d2d92b2":"68d6d921","chunk-4d2e8f23":"4c666f73","chunk-502b3c56":"ec6bf965","chunk-505564cc":"502ebc80","chunk-51830bbe":"05443992","chunk-534fc889":"e2c175b2","chunk-55a5cd42":"d88f9a40","chunk-56f73d72":"7ba77993","chunk-5c79e807":"cce296ab","chunk-5ed3eb64":"e6dbbe9f","chunk-60929f6b":"886dcd37","chunk-6450c4d9":"84fa516f","chunk-6a65b256":"734b08ba","chunk-6c72069e":"8ca8cdf9","chunk-6f9b3e6e":"6824aee3","chunk-7254f54c":"6cdc10f3","chunk-72d235fa":"7e75c212","chunk-7474ca6a":"c44db8de","chunk-77e41e03":"b9a4597e","chunk-792672a0":"7e699ad2","chunk-7a83ed1a":"17977871","chunk-7b143a86":"018cb593","chunk-7d6f6568":"c8617be8","chunk-7e90ba94":"4b61b954","chunk-8da7292e":"2a4f33f8","chunk-8e59b7be":"4154075c","chunk-9672f91e":"07474dc7","chunk-a65d7c72":"1a68047f","chunk-ae49f4fa":"df2bb2c2","chunk-b3a6dac6":"282c235c","chunk-bb1aa296":"41e2ef9b","chunk-c56e2642":"211a2f3a","chunk-d07f9196":"2e910aaf","chunk-dc2e5e3a":"8998a3b4","chunk-f9cae19e":"0d44c19b","chunk-ffd68490":"fc9bb99b","desktop_home":"0b975fad","desktop_layout":"8c853f03","desktop_manage-account":"0481b989","desktop_redemption":"8f683233","desktop_settings":"b411ac1d","forget-password~login":"938bba32","forget-password":"8b7f9344","login":"0dfa499d","fulfillment":"c683d5a0","layout-login":"10f4e646","mobile_home":"82081f9e","mobile_layout":"32e7550f","mobile_redemption":"a8a86ec3","mobile_user":"1de07c50","set-password":"4d580133","verify-token":"8823729c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-51830bbe":1,"chunk-792672a0":1,"desktop_home":1,"desktop_layout":1,"desktop_manage-account":1,"desktop_redemption":1,"desktop_settings":1,"forget-password~login":1,"forget-password":1,"login":1,"fulfillment":1,"layout-login":1,"mobile_home":1,"mobile_layout":1,"mobile_redemption":1,"mobile_user":1,"verify-token":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"desktop_home":"desktop_home","desktop_layout":"desktop_layout","desktop_manage-account":"desktop_manage-account","desktop_redemption":"desktop_redemption","desktop_settings":"desktop_settings","forget-password~login":"forget-password~login","forget-password":"forget-password","login":"login","fulfillment":"fulfillment","layout-login":"layout-login","mobile_home":"mobile_home","mobile_layout":"mobile_layout","mobile_redemption":"mobile_redemption","mobile_user":"mobile_user","set-password":"set-password","verify-token":"verify-token"}[chunkId]||chunkId) + "." + {"chunk-0db6f456":"31d6cfe0","chunk-0df38b29":"31d6cfe0","chunk-1285c570":"31d6cfe0","chunk-16b3d45c":"31d6cfe0","chunk-18447cb4":"31d6cfe0","chunk-1a2de8f4":"31d6cfe0","chunk-1b7fd891":"31d6cfe0","chunk-1c4bb97c":"31d6cfe0","chunk-21b34fe2":"31d6cfe0","chunk-29255102":"31d6cfe0","chunk-2a459ed1":"31d6cfe0","chunk-2c7f2666":"31d6cfe0","chunk-2d0a3c3b":"31d6cfe0","chunk-2d0cfad7":"31d6cfe0","chunk-2d0de76c":"31d6cfe0","chunk-2d0f1136":"31d6cfe0","chunk-2d229396":"31d6cfe0","chunk-2f1ad42e":"31d6cfe0","chunk-31475960":"31d6cfe0","chunk-3bd7cd7e":"31d6cfe0","chunk-3c705d88":"31d6cfe0","chunk-3d0a6901":"31d6cfe0","chunk-43b7ffe8":"31d6cfe0","chunk-4420fbcc":"31d6cfe0","chunk-4a20cf53":"31d6cfe0","chunk-4a20f8c4":"31d6cfe0","chunk-4aba7826":"31d6cfe0","chunk-4d2d92b2":"31d6cfe0","chunk-4d2e8f23":"31d6cfe0","chunk-502b3c56":"31d6cfe0","chunk-505564cc":"31d6cfe0","chunk-51830bbe":"819092da","chunk-534fc889":"31d6cfe0","chunk-55a5cd42":"31d6cfe0","chunk-56f73d72":"31d6cfe0","chunk-5c79e807":"31d6cfe0","chunk-5ed3eb64":"31d6cfe0","chunk-60929f6b":"31d6cfe0","chunk-6450c4d9":"31d6cfe0","chunk-6a65b256":"31d6cfe0","chunk-6c72069e":"31d6cfe0","chunk-6f9b3e6e":"31d6cfe0","chunk-7254f54c":"31d6cfe0","chunk-72d235fa":"31d6cfe0","chunk-7474ca6a":"31d6cfe0","chunk-77e41e03":"31d6cfe0","chunk-792672a0":"8cf4c2fc","chunk-7a83ed1a":"31d6cfe0","chunk-7b143a86":"31d6cfe0","chunk-7d6f6568":"31d6cfe0","chunk-7e90ba94":"31d6cfe0","chunk-8da7292e":"31d6cfe0","chunk-8e59b7be":"31d6cfe0","chunk-9672f91e":"31d6cfe0","chunk-a65d7c72":"31d6cfe0","chunk-ae49f4fa":"31d6cfe0","chunk-b3a6dac6":"31d6cfe0","chunk-bb1aa296":"31d6cfe0","chunk-c56e2642":"31d6cfe0","chunk-d07f9196":"31d6cfe0","chunk-dc2e5e3a":"31d6cfe0","chunk-f9cae19e":"31d6cfe0","chunk-ffd68490":"31d6cfe0","desktop_home":"9981df28","desktop_layout":"a57145f0","desktop_manage-account":"d9f742a0","desktop_redemption":"0257dbdd","desktop_settings":"9226f201","forget-password~login":"1e68101d","forget-password":"d7cc970f","login":"2c04e7f7","fulfillment":"208e314d","layout-login":"ae1e8514","mobile_home":"c4d2c164","mobile_layout":"018228ea","mobile_redemption":"b6372ea2","mobile_user":"b0493c3c","set-password":"31d6cfe0","verify-token":"b5d7d12b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.klook.com/s/dist_web/klook-counter-web/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
